var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-chat"},[(_vm.iframeSrc)?_c('vue-friendly-iframe',{staticClass:"admin-chat__iframe",attrs:{"src":_vm.iframeSrc}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }